
import './styles.css';
import InsaneTable from '../../component/insane-table';

function MaintenanceResultMT() {
    const tableOption = {
        tableName: "WorkOrders",
        className: "insane-table-dashboard",
        search: [
            {
                reqName: "search_equipment_tagid",
                displayName: "Equipment TagID",
                element: "input",
                placeholder: "Enter Equipment TagID."
            },
            {
                reqName: "workorderno",
                displayName: "Work order No",
                element: "input",
                placeholder: "Enter Work order No."
            },
            {
                displayName: "Start date",
                attName: "startdate",
                element: "datetime-local"
            }
        ],
        mapTable: [
            {
                displayName: "Work order No",
                attName: "workorderno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Work order desc",
                attName: "workorderdesc",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Equipment TagID",
                attName: "equipment_tagid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Start date",
                attName: "startdate",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Finish date",
                attName: "finishdate",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Plant TagID",
                attName: "plant_tagid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/mt/workorder/get",
                dataReq: {
                    "index": 0,
                    "count": 10
                }
            },
            insert: {
                enable: false,
                url: "/admin/mt/workorder/update",
                dataReq: {}
            },
            update: {
                enable: false,
                url: "/admin/mt/workorder/update",
                dataReq: {}
            },
            delete: {
                enable: false,
                url: "/admin/mt/workorder/delete",
                dataReq: {}
            }
        },
        action: [
            {
                name: "MT Result",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/maintenance/result-mt/view"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Select Work Order.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default MaintenanceResultMT;